import { render } from "./Team.vue?vue&type=template&id=82fb35c4&scoped=true"
import script from "./Team.vue?vue&type=script&lang=js"
export * from "./Team.vue?vue&type=script&lang=js"

import "./Team.vue?vue&type=style&index=0&id=82fb35c4&lang=scss&scoped=true"

import exportComponent from "C:\\websites\\kroechkwis-master\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82fb35c4"]])

export default __exports__